module.exports = __webpack_public_path__ + "static/img/index_seven_image.913d944.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_seven_image.png
// module id = agDa
// module chunks = 1